import React, { FC } from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@igooods/ui-kit';
import BlockTitle from 'Components/landings/BlockTitle';
import Row from 'Components/Grid/Row';
import Col from 'Components/Grid/Col';
import MobileTruckImg from './images/truck-mobile.png';
import MobileTruckRetinaImg from './images/truck-mobile@2x.png';
import DesktopTruckImg from './images/truck-desk.png';
import DesktopTruckRetinaImg from './images/truck-desk@2x.png';
import Text from 'Components/Typography/Text';
import { FontSize, FontWeight, FontFamily } from 'theme';
import { mediaSmDown, mediaMdDown, mediaLgDown } from 'theme/helpers/css';
import BlockContainer from 'Components/landings/BlockContainer';

const PictureCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

const StepItem = styled(Flex).attrs({ top: true })`
  & + & {
    margin-top: 48px;

    ${mediaMdDown`
      margin-top: 28px;
    `}
  }
`;

const Item = styled(Text).attrs({
  fontWeight: FontWeight.bold,
  size: FontSize.m,
  fontFamily: FontFamily.secondFont,
})`
  ${mediaMdDown`
    font-size: 14px;
    line-height: 22px;
  `}
`;

const StepNumber = styled(Item)`
  margin-right: 18px;
  flex: 0 0 auto;

  ${mediaMdDown`
    margin-right: 12px;
  `}
`;

const StepText = styled(Flex).attrs({
  wrap: true,
  grow: true,
})``;

const StepTitle = styled(Item)`
  width: 40%;

  ${mediaMdDown`
    width: 100%;
  `}
`;

const StepDescription = styled(Text).attrs({
  size: FontSize.m,
})`
  width: 60%;
  padding-left: 48px;

  ${mediaLgDown`
    padding-left: 28px;
  `}

  ${mediaMdDown`
    width: 100%;
    padding-left: 0;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
  `}
`;

const Truck = styled.div`
  max-width: 545px;
  width: 100%;
  margin-left: auto;
  padding-left: 40px;

  ${mediaLgDown`
    margin-top: 40px;
  `}

  ${mediaSmDown`
    padding-left: 0;
    max-width: 335px;
  `}

  img,
  picture {
    width: 100%;
  }
`;

const PurchaseSteps: FC = () => {
  return (
    <BlockContainer>
      <Box
        mt={{ xs: 12, sm: 14, lg: 30, xl: 40 }}
        mb={{
          xs: 15,
          sm: 17,
          lg: 40,
          xl: 42,
        }}
      >
        <Row>
          <Col xs={12} sm={12} md={12} lg={7}>
            <h2>
              <BlockTitle>
                Вы&nbsp;заказываете продукты, а&nbsp;мы&nbsp;собираем и&nbsp;привозим их&nbsp;в&nbsp;удобное вам время
              </BlockTitle>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} md={6} lg={6}>
            <Box mt={{ xs: 7, sm: 10, lg: 20 }} pb={2}>
              <StepItem>
                <StepNumber>1</StepNumber>
                <StepText>
                  <StepTitle>Закажите продукты</StepTitle>
                  <StepDescription>
                    Выбор и&nbsp;акции&nbsp;— как в&nbsp;магазине, время доставки&nbsp;— как вам удобно.
                  </StepDescription>
                </StepText>
              </StepItem>
              <StepItem>
                <StepNumber>2</StepNumber>
                <StepText>
                  <StepTitle>Пикер соберет заказ</StepTitle>
                  <StepDescription>Согласует с&nbsp;вами замену, если что-то закончилось.</StepDescription>
                </StepText>
              </StepItem>
              <StepItem>
                <StepNumber>3</StepNumber>
                <StepText>
                  <StepTitle>Курьер привезет, когда вам нужно</StepTitle>
                  <StepDescription>Проверьте заказ, а&nbsp;потом оплатите.</StepDescription>
                </StepText>
              </StepItem>
            </Box>
          </Col>
          <PictureCol xs={12} sm={6} md={6} lg={6}>
            <Truck>
              <picture>
                <source media="(max-width: 768px)" srcSet={`${MobileTruckRetinaImg} 2x, ${MobileTruckImg} 1x`} />
                <source media="(min-width: 768px)" srcSet={`${DesktopTruckRetinaImg} 2x, ${DesktopTruckImg} 1x`} />
                <img src={DesktopTruckImg} alt="" data-loading="lazy" />
              </picture>
            </Truck>
          </PictureCol>
        </Row>
      </Box>
    </BlockContainer>
  );
};

export default PurchaseSteps;
